// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"answerMap_wrapper__1BJk4","map":"answerMap_map__2YIob","marker":"answerMap_marker__2QkhG"};